var _circle, _path, _path2, _path3, _path4, _path5, _path6, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 61,
    viewBox: "0 0 58 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 28,
    r: 22.5,
    fill: "black",
    stroke: "black",
    strokeWidth: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3572 37.5322C19.3572 38.9758 20.4986 40.1172 21.9422 40.1172C23.3857 40.1172 24.5272 38.9758 24.5272 37.5322V32.8322L27.4815 30.0794L34.1957 38.8751C34.7665 39.6136 35.3708 40.1172 36.3779 40.1172C37.8886 40.1172 38.9965 39.0429 38.9965 37.5994C38.9965 36.8272 38.6943 36.2901 38.2915 35.7865L31.0736 26.7222L37.6872 20.5451C38.2579 20.0079 38.6272 19.4036 38.6272 18.5979C38.6272 17.3222 37.6872 16.2144 36.2436 16.2144C35.3372 16.2144 34.6993 16.5836 34.0615 17.2215L24.5272 26.6886V18.7994C24.5272 17.3558 23.3857 16.2144 21.9422 16.2144C20.4986 16.2144 19.3572 17.3558 19.3572 18.7994V37.5322Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9999 15.3215L35.4285 27.1183L48.9999 41.5715V15.3215Z",
    fill: "#E67079"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5715 4.42847V19.7856L40.7858 7.09927L27.5715 4.42847Z",
    fill: "#CBFF38"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5715 35.5V51.5714L39.7144 49.5231L27.5715 35.5Z",
    fill: "#50EAFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.902 27.2172L5.07153 26.9287L8.28582 39.7859L22.902 27.2172Z",
    fill: "#FFDA42"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.15283 26.1995L24.7926 26.5334L7.87355 41.0823L4.15283 26.1995ZM5.98999 27.6579L8.69785 38.4894L21.0111 27.901L5.98999 27.6579Z",
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_322_1320)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 28,
    r: 26.5,
    stroke: "white",
    strokeWidth: 3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_322_1320",
    x: 0,
    y: 0,
    width: 58,
    height: 61,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.29 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_322_1320"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_322_1320",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.991a8ee1b0e330897e8857994a9f0599.svg";
export { ForwardRef as ReactComponent };